import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';
import Typography from '~/components/Typography';

interface Props {
  text: string | React.ReactNode;
  color?: string;
}

const ThemedNavGroupTitle = ({ text, color }: Props) => {
  const { webTheme } = useWebThemeContext();

  return (
    <Typography
      as="p"
      size={'xs'}
      weight="semibold"
      color={color || webTheme?.footer_text_color}
      fontFamilyv2={webTheme?.font_header}
    >
      {text}
    </Typography>
  );
};

export default ThemedNavGroupTitle;
